import { object, SchemaOf, string } from 'yup';

import { MAX_STRING_LENGTH_YUP_TEMPLATE, MIN_STRING_LENGTH_YUP_TEMPLATE, REQUIRED_FIELD } from '@/config/text.const';


export type Fields = {
  reasonCode: string;
  reasonName: string;
};

export const initialValues: Fields = {
  reasonCode: '',
  reasonName: '',
};

export const validationSchema: SchemaOf<Fields> = object().shape({
  reasonCode: string()
    .min(1, MIN_STRING_LENGTH_YUP_TEMPLATE)
    .max(10, MAX_STRING_LENGTH_YUP_TEMPLATE)
    .required(REQUIRED_FIELD),

  reasonName: string()
    .min(1, MIN_STRING_LENGTH_YUP_TEMPLATE)
    .max(100, MAX_STRING_LENGTH_YUP_TEMPLATE)
    .required(REQUIRED_FIELD)
    .test((value, context) => {
      const regExp = new RegExp(/[0-9a-z]/gmi);

      if (typeof value === 'string' && regExp.test(value)) {
        return true;
      }

      return context.createError({
        path: 'reasonName',
        message: 'Only alphanumeric characters are allowed'
      });
    }),
});
